export class UtilNetwork {
    static get IsNetworkOk(): boolean {
        return navigator.onLine;
    }
}